




















import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { SimpleAccountViewer } from "../account/";
import { DeveloperIndicator } from "../developer";
import { ViewMenu } from "../system";
import { ViewNameIndicator } from "../system/viewers";
import { HelpView } from "../help";
import { IStyleHeaderWindowNameWindowsConfiguration } from "../../domain/configuration";

@Component({
  components: {
    SimpleAccountViewer,
    ViewMenu,
    ViewNameIndicator,
    HelpView,
    DeveloperIndicator,
  }
})
export default class HeaderPane extends Mixins() {
  get isHeaderMessageVisible(): boolean {
    return this.$configuration.behavior.header.message.isEnable;
  }

  get headerMessage(): string {
    return this.$configuration.behavior.header.message.displayText;
  }

  get headerMessageStyleProperties(): any {
    return this.$configuration.behavior.header.message.styleProperties;
  }

  get windows(): IStyleHeaderWindowNameWindowsConfiguration[] {
    return this.$configuration.style.header.windowName.windows;
  }

  get style(): any {
    const routeName = (this.$route.name ? this.$route.name : "").trim();
    const configuration = Enumerable.from(this.windows).firstOrDefault(w => w.expression && new RegExp(w.expression).test(routeName));
    return configuration && configuration.style
      ? {
        backgroundColor: configuration.style.backgroundColor,
        color: configuration.style.color,
      }
      : null;
  }
}
